module.exports = __webpack_public_path__ + "img/23_82.557608a6.png";